import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SharedService } from 'src/app/shared/shared.service';
import { ordersService } from '../../services/orders.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { STATUS } from 'src/app/constants/status.constant';
import { DatePipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { RegisterService } from 'src/app/auth/container/registration-module/register.service';
import { PATTERNS } from 'src/app/constants/constants/constants';
import { masterServices } from 'src/app/module/master/services/ems-services.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AssignTyrePositionComponentComponent } from '../assign-tyre-position-component/assign-tyre-position-component.component';
import { TyrePositionComponentDrag } from '../tyre-position/tyre-position.component';
import { trailerTyrePositionComponentDrag } from '../trailer-tyre-position/trailer-tyre-position.component';

@Component({
  selector: 'app-ne-add-order',
  templateUrl: './ne-add-order.component.html',
  styleUrls: ['./ne-add-order.component.css'],
  providers: [ConfirmationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NeAddOrderComponent implements OnInit, OnDestroy {
  fastTagList: any;
  jobForm: FormGroup;
  minDate: Date = new Date();
  editTrue: boolean = false;
  EditData: any;
  truckList: any;
  allCatagory: any;
  sendCatagoryId: any;
  UserDetails: any;
  maxDate: Date = new Date();
  batteryList:  any[] = [];tyrePosition: any;
;
  tyreList: any;
  insuranceList: any;
  vendorsList: any;

  // Batteries =========================
  selectedBatteries: any[] = [];
  form!: FormGroup;
  selectedTyre: any[] = [];
  pollutionVendorList: any;
  selectedFiles:FileList  | null = null;
  currentFile?: File;
  progress = 0;
  @ViewChild('uploadVendorInput') uploadVendorInput!: ElementRef;
  @ViewChild('uploadInsuranceInput') uploadInsuranceInput!: ElementRef;
  @ViewChild('uploadPollutionInput') uploadPollutionInput!: ElementRef;
  
  insuranceUploadUrl: string | null = null;selectedTruck: any;
  trailerList: any;
  selectedTrailer: any;
  selectedTyreTrailer: any[] = [];
  trailertyreList: any;
  allTyres: any[] = [];;
  truckDetails: any;
;
  pollutionUploadUrl: string | null = null;
  vendorUploadUrl: string | null = null;

  ref: DynamicDialogRef | undefined;
  savedTyreComponents: any[] = [];
saveBatteryComponents: any[] = [];

savedTruckTyres: any[] = [];
savedTrailerTyres: any[] = [];
tyreBrandDisplay: string = '';

  constructor(
    private fb: FormBuilder,
    public sharedService: SharedService,
    private ordersService: ordersService,
    public dialogRef: DynamicDialogRef,
    private datePipe: DatePipe,
    public data: DynamicDialogConfig,
    private registerService: RegisterService,
    private masterServices: masterServices,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService
  ) {
    console.log('data', data);
    this.editTrue = data?.data?.edit
    this.tyrePosition = data?.data?.tyrePosition

    if(this.editTrue){
      this.ordersService.getTruckBuildById(data?.data?.editData?.id).subscribe((res: any) => {
        this.truckDetails = res.responseObject;   
        this.truckDetails.component.forEach((item: any) => {
          if (item.componentType === 'Tyre') {
            this.savedTyreComponents.push(item);
            if (item.associationType === 'TRUCK') {
              this.savedTruckTyres.push(item);
            }
            if (item.associationType === 'TRAILER') {
              this.savedTrailerTyres.push(item);
            }
          }
          if (item.componentType === 'Battery') {
            this.saveBatteryComponents.push(item);
          }
        });
        // 🔽 APIs call AFTER edit API completed
        this.initPage(data);
      })
    } else {
      this.initPage(data);
    }
    this.jobForm = this.fb.group({ remarks: new FormControl(null), // jobLineItems: this.fb.array([this.createJobLineItem()]), version: new FormControl(null), 
});



  }
  initPage(data:any){

    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!);
    this.UserDetails = JSON.parse(localStorage.getItem('UserDetails')!);
    this.sendCatagoryId = this.setId();
    this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString());

    this.getTruckInfo();
    this.getFastTagInfo();
    this.getBatteryList();
    this.getInsuranceInfo();
    this.getTyreList();
    this.getVendorInfo();
    this.getTrailerInfo();
    setTimeout(() => { this.patchData(data); 
      if(this.tyrePosition){
        this.disabledFormFiled(data)
      }
    }, 1500);

  }
  ngOnInit(): void {
    this.jobForm = this.fb.group({
      truckId: [null, Validators.required],

      brandModel: [''],
      truckType: [''],
      manufacturingDate: [''],
      onboardedDate: [''],

      trailerId: [null],

      trailerTyreCap: [''],
      trailerType: [''],
      manufacturingTrailerDate: [''],
      trailerFromDate: [''],


      pollutionId: [null, Validators.required],
      pollutionNumber: [null, Validators.required],
      pollutionValidityFrom: ['', Validators.required],
      pollutionValidityTill:['', Validators.required],

      insurerId: [null, Validators.required],
      insuranceNumber: [null, Validators.required],
      insuranceValidityFrom: ['', Validators.required],
      insuranceValidityTill:['', Validators.required],

      vendorId: [null, Validators.required],
      vendorName: [null, Validators.required],
      vendorValidityFrom: ['', Validators.required],
      vendorValidityTill:['', Validators.required],


      batteryListAdd: [[], Validators.required],
      tyreListAdd:[[], Validators.required],
      trailerListAdd:[[]]
      
    });

  }

   onTruckChange(truckId: number) {
      if (!truckId) {
        this.resetTruckFields();
        return;
      }
      this.selectedTruck = this.truckList.find((t:any) => t.id === truckId);
      // if (!this.selectedTruck) return;
      const mfgDateObj = this.ordersService.parseCustomDate(this.selectedTruck.mfgDate);
      const purchaseDateObj = this.ordersService.parseCustomDate(this.selectedTruck.purchaseDate);
      this.selectedTruck.purchaseDateObjNew = moment(
  this.selectedTruck.purchaseDate,
  'DD-MM-YYYY HH:mm:ss Z'
).toDate();
      setTimeout(() => {
        this.jobForm.patchValue({
          brandModel: this.selectedTruck.brandName,
          truckType: this.selectedTruck.modelName,
          manufacturingDate: this.datePipe.transform(mfgDateObj,'dd-MM-yyyy'),
          onboardedDate: this.datePipe.transform(purchaseDateObj,'dd-MM-yyyy')
        });
      });
      // this.cd.detectChanges();
    }

    onVendorhange(Id: number) {
      if (!Id) {
        this.resetTruckFields();
        return;
      }
      const selectedTruck = this.vendorsList.find((t:any) => t.id === Id);
      if (!selectedTruck) return;
      this.jobForm.patchValue({
        vendorName: selectedTruck.vendorName,

      });
    }

    resetTruckFields() {
      this.selectedTyre = []
      this.selectedTruck =[]
      this.selectedTrailer = []
      this.selectedTyreTrailer = []
      
      this.jobForm.patchValue({
        batteryListAdd: ' ',
        tyreListAdd: ' ',
        trailerListAdd: ' ',
        brandModel: '',
        truckType: '',
        manufacturingDate: '',
        onboardedDate: ''
      });
    }
resetTrailerFields(){
      this.selectedTrailer = []
      this.selectedTyreTrailer = []
      this.jobForm.patchValue({
        trailerFromDate: ' ',
        trailerListAdd:'',
        manufacturingDate:''
      });
}
  ngOnDestroy(): void {}

  // Battery ===============
  onBatterySelect(selected: any[]) {
    const capacity = this.selectedTruck?.batteryCapacity || 0;
    if (selected.length > capacity) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit reached',
        detail: `Only ${capacity} Battery allowed`
        });
        selected = selected.slice(0, capacity);
        this.jobForm.get('batteryListAdd')?.setValue(selected);
    }
    this.selectedBatteries = selected || [];
  }

  onTrailerChange(trailerId: number) {
      if (!trailerId) {
        // this.resetTruckFields();
        this.resetTrailerFields();
        return;
      }
      this.selectedTrailer = this.trailerList.find((t:any) => t.id === trailerId);
      if (!this.selectedTrailer) return;
      const mfgDateObj = this.ordersService.parseCustomDate(this.selectedTrailer.mfgDate);
      // const trailerFromDate = this.ordersService.parseCustomDate(this.truckDetails.trailerFromDate);
       setTimeout(() => {
          this.jobForm.patchValue({
            trailerType: `${this.selectedTrailer.trailerType}`,
            trailerTyreCap: this.selectedTrailer.trailerTyreCapacity,
            manufacturingTrailerDate: mfgDateObj ? this.datePipe.transform(mfgDateObj, 'dd-MM-yyyy'): '',
            // trailerFromDate: trailerFromDate ? this.datePipe.transform(trailerFromDate, 'dd-MM-yyyy'): '',
          });
       });
      this.cd.detectChanges();

    }
    
  onTrailerTyreChange(selected: any[]) {
    const capacity = this.selectedTrailer?.trailerTyreCapacity || 0;
    if (selected.length > capacity) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit reached',
        detail: `Only ${capacity} Trailer Tyre allowed`
        });
        selected = selected.slice(0, capacity);
        this.jobForm.get('trailerListAdd')?.setValue(selected);
    }
    this.selectedTyreTrailer = selected || [];
    const selectedIds = this.selectedTyreTrailer.map(x => x.id);

    this.tyreList = this.allTyres.filter(
      (tyre:any) => !selectedIds.includes(tyre.id)
    );
  }

  getBrandModelList(): string {
   if (!this.selectedBatteries?.length) return '';
     const uniqueBrands = Array.from(
        new Set(this.selectedBatteries.map(b => b.brandName))
      );
      if (uniqueBrands.length > 1) {
        return uniqueBrands.slice(0, 1).join('/') + ' (Mixed)';
      }
      return uniqueBrands.join('/');
  }

    // Tyre ===============
  onTyreSelect(selected: any[]) {
    const capacity = this.selectedTruck?.tyreCapacity || 0;
    if (selected.length > capacity) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit reached',
        detail: `Only ${capacity} tyres allowed`
        });
        selected = selected.slice(0, capacity);
        this.jobForm.get('tyreListAdd')?.setValue(selected);
    }
    this.selectedTyre = selected || [];

    // Trailer list se remove karo jo tyre select ho chuke
    const selectedIds = this.selectedTyre.map(x => x.id);

    this.trailertyreList = this.allTyres.filter(
      (tyre:any) => !selectedIds.includes(tyre.id)
    );
    this.updateTyreBrandList()
  }
  updateTyreBrandList() {
  if (!this.selectedTyre?.length) {
    this.tyreBrandDisplay = '';
    return;
  }

  const uniqueBrands = Array.from(
    new Set(this.selectedTyre.map((b:any) => b.brandName))
  );

  this.tyreBrandDisplay =
    uniqueBrands.length > 2
      ? uniqueBrands.slice(0, 2).join('/') + ' (Mixed)'
      : uniqueBrands.join('/');

      console.log(this.tyreBrandDisplay,"============")
}
  // getTyreBrandList(): string {
  //   if (!this.selectedTyre?.length) return '';
  //   const uniqueBrands = Array.from(
  //     new Set(this.selectedTyre.map(b => b.brandName))
  //   );
  //   if (uniqueBrands.length > 2) {
  //     return uniqueBrands.slice(0, 2).join('/') + ' (Mixed)';
  //   }
  //   return uniqueBrands.join('/');
  // }
  getTrailerBrandList(): string {
    if (!this.selectedTyreTrailer?.length) return '';
    const uniqueBrands = Array.from(
      new Set(this.selectedTyreTrailer.map((b:any) => b.brandName))
    );
    if (uniqueBrands.length > 2) {
      return uniqueBrands.slice(0, 2).join('/') + ' (Mixed)';
    }
    return uniqueBrands.join('/');
  }


  getTruckInfo() {
    let postData: any[] = [];

    if(this.editTrue){
      postData = [
        
      ];
    }else{
      postData = [
        {
          key: 'STATUS',
          value: 'Active',
        },
      ];
    }
    this.ordersService.getTruckInfo(postData, 0, 500, 'id', 'DESC').subscribe(
      (data: any) => {
        this.truckList = data?.responseObject?.content;
      },(err) => {
        this.truckList = [];
      },
    );
  }
  getFastTagInfo() {
    this.masterServices.getFastTagInfo([], 0, 500, 'id', 'DESC').subscribe((data: any) => {
        this.fastTagList = data?.responseObject?.content;
    });
  }
  getBatteryList() {
    // let postData: any[] = [];
      // if(this.editTrue){
      //   postData = [];
      // }else{
       let postData = [
          {
          key: 'COMPONENT_TYPE_IN',
          value: 'Battery',
        },
        {
          key: 'STATUS_IN',
          value: 'Active,new,idle  ',
        }
        ];
      // }
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
          this.batteryList = data?.responseObject?.content;
          this.batteryList = [
          ...this.batteryList,
          ...this.saveBatteryComponents
        ];
          // this.batteryList.push(this.saveBatteryComponents);

        },(err) => {
          this.batteryList = [];
        },
      );
  }
  getTyreList() {
    // let postData: any[] = [];
    // if(this.editTrue){
    //   postData = [];
    // }else{
      let postData = [
        {
        key: 'COMPONENT_TYPE_IN',
        value: 'Tyre',
      },
      {
        key: 'STATUS_IN',
        value: 'new,idle  ',
      }
      ];
    // }
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
          // this.tyreList = data?.responseObject?.content;
          // this.trailertyreList = data?.responseObject?.content;
          this.allTyres = data?.responseObject?.content || [];
          this.tyreList = [...this.allTyres, ...this.savedTruckTyres];
          this.trailertyreList = [...this.allTyres, ...this.savedTrailerTyres];

        },(err) => {

          if (this.editTrue){
          this.tyreList = [...this.savedTruckTyres];
          this.trailertyreList = [...this.savedTrailerTyres];
          }else{
          this.tyreList = [];
          this.trailertyreList = []
        }
        this.cd.detectChanges()
      }
      );
  }
  getTrailerInfo() {
    let postData: any[] = [];
    if(this.editTrue){
      postData = [];
    }else{
      postData = [
        {
          key: 'STATUS_IN',
          value: 'Active,idle',
        },
      ];
    }
  
    this.masterServices.getTrailerInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
          this.trailerList = data?.responseObject?.content;
        },(err) => {
          this.trailerList = [];
        },
      );
  }
  getInsuranceInfo() {
    this.masterServices.getInsuranceInfo([], 0, 500, 'id', 'DESC').subscribe((data: any) => {
        this.insuranceList = data?.responseObject?.content;
      },(err) => {
        this.insuranceList = [];
      });
  }
  getVendorInfo() {
    this.masterServices.getVendorInfo([], 0, 500, 'id', 'DESC').subscribe((data: any) => {
        this.vendorsList = data?.responseObject?.content;
      },(err) => {
        this.vendorsList = [];
      });
  }

  setId(): (number | undefined)[] {
    const keys = ['pollutionVendor'];
    return keys.map((key) => this.allCatagory?.[key]?.id);
  }
  getQuickCodeListByCategoryId(ids: any) {
    this.registerService
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        this.pollutionVendorList = data?.responseObject?.pollutionVendor;
      });
  }

  // ================= Patch Data =================
  patchData(data: any) {
    this.editTrue = data?.data?.edit;
    if (data && data?.data && data?.data?.editData && data?.data?.edit) {
      if (data?.data?.editData) {
        this.EditData = data?.data?.editData;
        const trailerFromDate = moment( this.EditData?.trailerFromDate, 'DD-MM-YYYY HH:mm:ss Z',).toDate();
        const toDate = moment(
          this.EditData?.toDate,
          'DD-MM-YYYY HH:mm:ss Z',
        ).toDate();
        this.onTruckChange(this.EditData?.truckId)
        this.onTrailerChange(this.EditData?.trailerId)
          
          this.insuranceUploadUrl=this.EditData?.pucUrl;
          this.pollutionUploadUrl=this.EditData?.pucUrl;
          this.vendorUploadUrl=this.EditData?.vendorUrl;
          const componentTrailerTyre =[
            { "id":2,"serialNumber":"BAT-001"},
            { "id":4,"serialNumber":"BAT-002"},
            { "id":7,"serialNumber":"BAT-003"},
            { "id":10,"serialNumber":"BAT-003"},
            { "id":4,"serialNumber":"BAT-003"}
          ]
         const selectedBatteries = this.batteryList.filter((b:any) =>
            this.saveBatteryComponents.some(c => c.id === b.id)
          );
          // const selectedTyre = this.tyreList.filter((b:any) =>
          //   this.savedTruckTyres.some(c => c.id === b.id)
          // );
          const selectedTrailerTyre = this.trailertyreList.filter((b:any) =>
            this.savedTrailerTyres.some(c => c.id === b.id)
          );
          const selectedTyre = this.tyreList.filter((b: any) =>
            this.savedTruckTyres.some((c: any) => c.id === b.id)
          );
        this.jobForm.patchValue({
          truckId: this.EditData?.truckId,
          // trailerId:this.EditData?.trailerId,
          trailerId:this.EditData?.trailerId,
          batteryListAdd: selectedBatteries,
          tyreListAdd: selectedTyre,
          trailerListAdd:selectedTrailerTyre,
          pollutionId:this.EditData?.pucId,
          pollutionNumber:this.EditData?.puc,
          pollutionValidityFrom:this.EditData?.trailerFromDate ? moment( this.EditData?.pucValidityFrom, 'DD-MM-YYYY HH:mm:ss Z',).toDate(): '',
          pollutionValidityTill:this.EditData?.trailerFromDate ? moment( this.EditData?.pucValidityTill, 'DD-MM-YYYY HH:mm:ss Z',).toDate(): ''  ,

          insurerId:this.EditData?.insurerId,
          insuranceNumber:this.EditData?.insuranceNumber,
          insuranceValidityFrom:this.EditData?.trailerFromDate ? moment( this.EditData?.insuranceValidityFrom, 'DD-MM-YYYY HH:mm:ss Z',).toDate(): '' ,
          insuranceValidityTill:this.EditData?.trailerFromDate ? moment( this.EditData?.insuranceValidityTill, 'DD-MM-YYYY HH:mm:ss Z',).toDate(): '' ,

          vendorId:this.EditData?.vendorId,
          vendorName:this.EditData?.vendorName,
          vendorValidityFrom:this.EditData?.trailerFromDate ? moment( this.EditData?.vendorValidityFrom, 'DD-MM-YYYY HH:mm:ss Z',).toDate(): '' ,
          vendorValidityTill: this.EditData?.trailerFromDate ?moment( this.EditData?.vendorValidityTill, 'DD-MM-YYYY HH:mm:ss Z',).toDate(): '' ,
          trailerFromDate: this.EditData?.trailerFromDate ? moment( this.EditData?.trailerFromDate, 'DD-MM-YYYY HH:mm:ss Z',).toDate() : '',
          
          
        });
        this.onBatterySelect(selectedBatteries);
        this.onTyreSelect(selectedTyre);
        this.onTrailerTyreChange(selectedTrailerTyre)
        this.jobForm.get('truckId')?.disable();
        this.getBrandModelList()
        this.getTrailerBrandList()
      } else {
        this.EditData = data?.data?.editData;
      }
    }
  }

  disabledFormFiled(data:any){
      this.jobForm.get('truckId')?.disable();
       this.jobForm.disable();
  }

  // Submit
  submitAssembly(type:any) {
    console.log(this.jobForm.value.trailerListAdd)
    const formValue = this.jobForm.value;
    const batteryPayload = this.jobForm.value.batteryListAdd.map((item: any) => ({
      newComponentId: item.id,
      componentType: item.componentType,
      newComponentVersion: item?.version ?? null,

      // associationType:''
    }));
    const truckTyrePayload = this.jobForm.value.tyreListAdd.map((item: any) => ({
      newComponentId: item.id,
      componentType: item.componentType,
      associationType:'TRUCK',
      axelPosition: item?.axelPosition ?? null,
      newComponentVersion: item?.version ?? null,
      sideSlot: item?.sideSlot ?? null,
      selectedSlot: item?.selectedSlot ?? null
    }));
    const trailerTyrePayload = this.jobForm.value.trailerListAdd.map((item: any) => ({
      newComponentId: item.id,
      componentType: item.componentType,
      associationType:'TRAILER',
      axelPosition: item?.axelPosition ?? null,
      newComponentVersion: item?.version ?? null,
      sideSlot: item?.sideSlot ?? null,
      selectedSlot: item?.selectedSlot ?? null
    }));
    const payload = {
      id: null,
      commponentAssociation: [
        ...batteryPayload,
        ...truckTyrePayload,
        ...trailerTyrePayload
      ],
      'isTrailer':this.jobForm.value.trailerId ? 'true' : 'false',
      'trailerFromDate':formValue?.trailerFromDate ? this.datePipe.transform(formValue?.trailerFromDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
      'trailerId':this.jobForm.value.trailerId,

      'associatedTyres':this.jobForm.value.tyreListAdd?.length,
      'associatedBatteries':this.jobForm.value.batteryListAdd?.length,
      'associatedTrailerTyres':this.jobForm.value.trailerListAdd?.length,
      'truckId': formValue.truckId,
      'initialKmTravelled':this.selectedTruck?.initialKmTravelled,

      "isPuc": formValue.pollutionId && formValue.pollutionNumber ? true: null,
      'pucId':formValue.pollutionId,
      'puc':formValue.pollutionNumber,
      'pucValidityFrom':formValue.pollutionValidityFrom ? this.datePipe.transform(formValue?.pollutionValidityFrom, 'dd-MM-yyyy HH:mm:ss Z')  : null,
      'pucValidityTill':formValue.pollutionValidityTill ? this.datePipe.transform(formValue?.pollutionValidityTill, 'dd-MM-yyyy HH:mm:ss Z')  : null,
      'pucUrl':this.pollutionUploadUrl,

      "isInsurance": formValue.insurerId ? true : null,
      'insurerId':formValue.insurerId,
      'insuranceNumber':formValue.insuranceNumber,
      'insuranceValidityFrom':formValue.insuranceValidityFrom ? this.datePipe.transform(formValue?.insuranceValidityFrom, 'dd-MM-yyyy HH:mm:ss Z')  : null,
      'insuranceValidityTill':formValue.insuranceValidityTill ? this.datePipe.transform(formValue?.insuranceValidityTill, 'dd-MM-yyyy HH:mm:ss Z')  : null,
      'insuranceUrl':this.insuranceUploadUrl,
      
      'vendorId':formValue.vendorId,
      'vendorName':formValue.vendorName,
      'vendorValidityFrom':formValue.vendorValidityFrom ? this.datePipe.transform(formValue?.vendorValidityFrom, 'dd-MM-yyyy HH:mm:ss Z')  : null,
      'vendorValidityTill':formValue.vendorValidityTill ? this.datePipe.transform(formValue?.vendorValidityTill, 'dd-MM-yyyy HH:mm:ss Z')  : null,
      'vendorUrl':this.vendorUploadUrl,

      // component : []

      // ...formValue,
      status: type == 'draft' ? 'Draft':null,
      // fromDate: formValue.fromDate ? this.datePipe.transform(formValue.fromDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
    };
console.log('payload',payload)
    if (this.editTrue && this.EditData) {
      payload.id = this.EditData.id ?? null;
    }

    this.ordersService.getBuild(payload).subscribe((data: any) => {
      if (data) {
        this.dialogRef.close(data);
        // this._route.navigate(['/orders']);
      }
    });
  }



    selectFile(event: any , type:any): void {
    this.selectedFiles = event.target.files;
    const fileType = type
    if (
      event.target.files[0].type !==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
      event.target.files[0].type !== 'application/vnd.ms-excel'
    ) {
      // this.progress = 0;
      // this.uploadPath = null;
      // this.uploadFileName = null;
      // this.uploadVendorInput.nativeElement.value = null;
      // this.selectedFiles = undefined;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Uploaded file must be in excel format.',
      });
      return;
    }
    this.upload(fileType)
  }



   upload(type: any): void {
      // this.progress = 0;
      if (this.selectedFiles) {
          const file: File | null = this.selectedFiles.item(0);
        if (file) {
          this.currentFile = file;
  
          this.masterServices.upload(
            this.currentFile,
          ).subscribe({
            next: (event: any) => {
              if (event.type === HttpEventType.UploadProgress) {
                this.progress = Math.round((100 * event.loaded) / event.total);
                if (this.progress == 100) {
                  this.progress = 99;
                }
              } else if (event instanceof HttpResponse) {
                if(type == 'VENDOR'){
                  this.vendorUploadUrl = event.body.responseObject
                  this.cd.detectChanges();
                }else if(type == 'Pollution'){
                  this.pollutionUploadUrl = event.body.responseObject
                  this.cd.detectChanges();

                }else if(type = 'Insurance'){
                  this.insuranceUploadUrl = event.body.responseObject
                  this.cd.detectChanges();
                }
                // this.message = event.body.message;
                this.progress = 0;
                // this.uploadVendorInput.nativeElement.value = null;
                // this.messageService.add({
                //   severity: 'success',
                //   summary: 'Success',
                //   detail: 'Uploaded Successfully',
                // });
                // this.setInterval = setInterval(()=>{
                // this.intervalProgressList()
                setTimeout(() => {
                  // this.getListForCompleted();
                  // this.getlistForProgress()
                  // this.selectedType('none')
                  // this.selectUploadType = ''
                  // this.createPOForm.reset();
                }, 2000);
                // }
                // ,1000)
                // this.fileInfos = this.uploadService.getFiles();
              }
            },
            error: (err: any) => {
              // this.progress = 0;
              // this.uploadVendorInput.nativeElement.value = null;
              if (err.error && err.error.message) {
                const message = err.error.message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: err.error.message,
                });
              } else {
                const message = 'Could not upload the file!';
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: message,
                });
              }
  
              // this.currentFile = undefined;
            },
          });
        }
  
        // this.selectedFiles = undefined;
      }
    }

    removeFile(type:any){
      if(type == 'VENDOR'){
        this.vendorUploadUrl = null
      }else if(type == 'Pollution'){
        this.pollutionUploadUrl = null
      }if(type == 'Insurance'){
        this.insuranceUploadUrl = null
      }
      if (this.uploadVendorInput) {
        this.uploadVendorInput.nativeElement.value = null;
      }
      if (this.uploadInsuranceInput) {
        this.uploadInsuranceInput.nativeElement.value = null;
      }
      if (this.uploadPollutionInput) {
        this.uploadPollutionInput.nativeElement.value = null;
      }
      
    }


    closeDialog() {
       this.confirmationService.confirm({
        message: 'Are you sure you want to close?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.dialogRef.close();
        }
      });

    }

    assignTyrePosition(type: any,selectedTyre:any,selectedTypePosition:any) {
      // this.ref = this.dialogService.open(AddordersComponent, {
      this.ref = this.dialogService.open(AssignTyrePositionComponentComponent, {
        // header: `${type} Order`,
        header: `Assign Tyre Positions & Components`,
        data: type == 'Add' ? {
          configType: '8x4', 
          type: selectedTypePosition,
          selectedTyres: selectedTyre,
          axle:this.selectedTrailer?.axle,
          isEdit:this.editTrue,
          savedComponents:this.savedTyreComponents
        } : {
          // editData: this.selectedData,
          // edit: this.editContation
        },
        width: '70vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true,
        styleClass: 'no-close-icon-dialog',
      });
      this.ref.onClose.subscribe((data: any) => {
        if (data) {
          if(data?.data[0].component === 'Horse'){
            this.jobForm.value.tyreListAdd.forEach((el:any)=>{
              data?.data.forEach((ele:any)=>{
                if(ele.id == el.id){
                  el['axelPosition'] = ele.axlePosition
                  el['sideSlot'] = ele.sideSlot
                }
              })
            })
          }
          if(data?.data[0].component === 'Trailer'){
            this.jobForm.value.trailerListAdd.forEach((el:any)=>{
              data?.data.forEach((ele:any)=>{
                if(ele.id == el.id){
                  el['axelPosition'] = ele.axlePosition
                  el['sideSlot'] = ele.sideSlot
                }
              })
            })
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: data?.responseMessage,
          });
        }
      });
    }


     assignTyrePositionNew(type: any,selectedTyre:any,selectedTyreTrailer:any) {
      // this.selectedTruck
      // this.ref = this.dialogService.open(AddordersComponent, {
      this.ref = this.dialogService.open(TyrePositionComponentDrag, {
        // header: `${type} Order`,
        header: `Assign Tyre Positions & Components`,
        data: type == 'Add' ? {
          configType: this.selectedTruck?.configuration, 
          type: selectedTyreTrailer,
          selectedTyres: selectedTyre,
          axle:this.selectedTrailer?.axle,
          isEdit:this.editTrue,
          savedComponents:this.savedTyreComponents
        } : {
          // editData: this.selectedData,
          // edit: this.editContation
        },
        width: '70vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true,
        styleClass: 'no-close-icon-dialog',
      });
      this.ref.onClose.subscribe((data: any) => {
          if(data){
            this.jobForm.value.tyreListAdd.forEach((el:any)=>{
              data?.forEach((ele:any)=>{
                if(ele.id == el.id){
                  el['axelPosition'] = ele.axlePosition
                  el['sideSlot'] = ele.sideSlot
                  el['selectedSlot'] = ele.selectedSlot
                }
              })
            })
          }
          if(data?.data[0].component === 'Trailer'){
            this.jobForm.value.trailerListAdd.forEach((el:any)=>{
              data?.data.forEach((ele:any)=>{
                if(ele.id == el.id){
                  el['axelPosition'] = ele.axlePosition
                  el['sideSlot'] = ele.sideSlot
                }
              })
            })
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: data?.responseMessage,
          });
        console.log('this.jobForm.value.tyreListAdd',this.jobForm.value.tyreListAdd)
      });
    }



     assignTrailerTyrePositionNew(type: any,selectedTyre:any,selectedTypePosition:any) {
      // this.selectedTruck
      // this.ref = this.dialogService.open(AddordersComponent, {
      this.ref = this.dialogService.open(trailerTyrePositionComponentDrag, {
        // header: `${type} Order`,
        header: `Assign Trailer Tyre Positions & Components`,
        data: type == 'Add' ? {
          configType: this.selectedTrailer, 
          type: selectedTypePosition,
          selectedTyres: selectedTyre,
          axle:this.selectedTrailer?.axle,
          isEdit:this.editTrue,
          savedComponents:this.savedTyreComponents
        } : {
          // editData: this.selectedData,
          // edit: this.editContation
        },
        width: '70vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true,
        styleClass: 'no-close-icon-dialog',
      });
      this.ref.onClose.subscribe((data: any) => {
        console.log('===========',data)
           
          if(data){
            this.jobForm.value.trailerListAdd.forEach((el:any)=>{
              data?.forEach((ele:any)=>{
                if(ele.id == el.id){
                  el['axelPosition'] = ele.axlePosition
                  el['sideSlot'] = ele.sideSlot
                  el['selectedSlot'] = ele.selectedSlot
                }
              })
            })
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: data?.responseMessage,
          });
        console.log('this.jobForm.value.tyreListAdd',this.jobForm.value.trailerListAdd)
      });
    }
}
